import VueRouter from 'vue-router';
import Step1 from './pages/step-1.vue';
import Step2 from './pages/step-2.vue';
import Step2a from './pages/step-2a.vue';
import Step3 from './pages/step-3.vue';
import Step4 from './pages/step-4.vue';
import Step5 from './pages/step-5.vue';
import ThankYou from './pages/thank-you.vue';

let routes = [
    {
        path: '/book-a-test-drive',
        name: 'select-brand',
        component: Step1
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/book-a-test-drive',
        name: 'select-model',
        props: true,
        component: Step2
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/book-a-test-drive/:urlModel',
        name: 'select-options',
        props: true,
        component: Step2a
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/book-a-test-drive/:urlModel/select-dealer',
        name: 'select-dealer',
        props: true,
        component: Step3
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/book-a-test-drive/:urlModel/select-time',
        name: 'select-time',
        props: true,
        component: Step4
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/book-a-test-drive/:urlModel/your-details',
        name: 'your-details',
        props: true,
        component: Step5
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/book-a-test-drive/:urlModel/thank-you',
        name: 'thank-you',
        props: true,
        component: ThankYou
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
    base: '/',
    linkActiveClass: 'active'
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    next();
});

export default router;